import styled, { keyframes } from 'styled-components'

const spinner = keyframes`
  0% { transform: rotate(0deg); }

  100% { transform: rotate(360deg); }
`

export const Container = styled.div`
    min-height: 400px;
    /* margin-top: 20px; */
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Loader = styled.span`
    border: 10px solid #eaf0f6;
    border-radius: 50%;
    border-top: 10px solid #15ed41;
    width: 80px;
    height: 80px;
    animation: ${spinner} 2s linear infinite;
`

// export const Container = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   /* min-height: 400px; */
//   /* margin-top: 20px; */
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: rgba(0, 0, 0, 0.4);
// `;

// export const Loader = styled.span`
// position: relative;
//   border: 10px solid #EAF0F6;
//   border-radius: 50%;
//   border-top: 10px solid #15ED41;
//   width: 80px;
//   height: 80px;
//   animation: ${spinner} 2s linear infinite;
// `;
